import { SLIDES_DATA } from "@/components/sections/awards";
import { Component } from "@builder.io/sdk";

export const awardsConfig: Component = {
  name: "Awards",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "awards",
      helperText: "Unique identifier for the section",
      advanced: true,
    },
    {
      name: "slides",
      type: "list",
      subFields: [
        {
          name: "logo",
          type: "file",
          allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
          required: true,
          friendlyName: "Logo URL",
          helperText: "URL or path to the logo. Logo should be 196x90px",
        },
        {
          name: "name",
          type: "string",
          friendlyName: "Alt Text",
        },
      ],
      defaultValue: SLIDES_DATA,
    },
  ],
};
